import { render, staticRenderFns } from "./Webpages.vue?vue&type=template&id=ea0c585c&scoped=true&"
import script from "./Webpages.vue?vue&type=script&lang=js&"
export * from "./Webpages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0c585c",
  null
  
)

export default component.exports